module.exports = __webpack_public_path__ + "img/coin-use-2.8634439f.jpg";